import { useQuery } from '@tanstack/react-query';
import { useNavigate, Link } from '@tanstack/react-router';
import { useAuth } from '../lib/auth';
import { config } from '../../config';

async function fetchHealth() {
  const response = await fetch(`${config.apiUrl}/api/health`);
  if (!response.ok) throw new Error('Failed to fetch health');
  return response.json();
}

export function IndexRoute() {
  const navigate = useNavigate();
  const { user, signOut, signOutPending } = useAuth();

  const { data, isLoading, error } = useQuery({
    queryKey: ['health'],
    queryFn: fetchHealth,
  });

  const handleSignOut = async () => {
    await signOut();
    navigate({ to: '/login', search: {} });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <h1 className="text-xl font-bold text-gray-900">Avatar</h1>
          <div className="flex items-center gap-4">
            <span className="text-sm text-gray-600">{user?.email}</span>
            <button
              onClick={handleSignOut}
              disabled={signOutPending}
              className="px-3 py-1.5 text-sm bg-gray-100 hover:bg-gray-200 disabled:bg-gray-50 text-gray-700 rounded-md transition-colors"
            >
              {signOutPending ? 'Signing out...' : 'Sign Out'}
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Welcome back!</h2>
          <p className="text-gray-600 mb-6">
            You are signed in as <strong>{user?.email}</strong>
          </p>

          {/* Navigation */}
          <div className="border-t pt-6 mb-6">
            <Link
              to="/chat"
              className="inline-block rounded-md bg-gray-900 px-4 py-2 text-sm text-white hover:bg-gray-800 transition-colors"
            >
              Open Agent Chat
            </Link>
          </div>

          {/* API Health Check */}
          <div className="border-t pt-6">
            <h3 className="text-md font-medium text-gray-900 mb-3">API Status</h3>
            {isLoading && <p className="text-gray-500">Checking API health...</p>}
            {error && <p className="text-red-600">Error: {error.message}</p>}
            {data && (
              <pre className="bg-gray-100 p-4 rounded-md text-sm overflow-x-auto text-gray-900">
                {JSON.stringify(data, null, 2)}
              </pre>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}
